import { tv } from '@otomoro/helpers/mergeClasses'
import { VariantProps } from 'tailwind-variants'

export const markets = tv({
	slots: {
		base: 'flex flex-col px-2 md:px-4 max-w-[172rem] mx-auto',
		container: 'flex flex-col gap-[2rem] mt-1 md:mt-4 md:gap-[4rem] overflow-hidden',
		stackContainer: 'flex flex-col rounded-l gap-y-2',
		image: 'h-full w-full  object-cover',
		card: 'z-[2] max-w-[calc(100%-3rem)] md:max-w-[42.5rem] bottom-[1.5rem] left-[1.5rem] md:bottom-3 md:left-3 absolute',
		figure:
			'rounded-l overflow-hidden aspect-[33.5/60] h-[75vh] md:aspect-auto md:max-h-[70rem] relative',
	},
	variants: {},
})

export type DateCardsVariants = VariantProps<typeof markets>
